import cls from "classnames";
import ReviewCard from "./ReviewCard";

function ReviewSlider({ reviews, getReviews, totalReviewCount }) {
  return (
    <>
      <ul className={cls("flex mt-6 space-x-3 hide-scrollbar")}>
        {reviews?.map((review, id) => {
          return <ReviewCard key={review.uid} review={review} />;
        })}
      </ul>{" "}
      {totalReviewCount > reviews.length ? (
        <button
          className="lg:hidden text-[#A6A6A6] text-center underline mt-6 lg:mt-8 w-full min-w-max"
          onClick={getReviews}
        >
          + more reviews
        </button>
      ) : null}
    </>
  );
}

export default ReviewSlider;
